
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCentIec as ObiCentIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cent-iec.js';
 
 
 

 
 export const ObiCentIec = createComponent({
   react: React,
   tagName: 'obi-cent-iec',
   elementClass: ObiCentIecElement,
   events: {
     
   }
  });
 
 